import classNames from 'classnames';

import ThumbsUpIcon from '@svg/thumbs-up.svg';

// styles
import s from './SellerRatingThumbCount.sss';

// types
type SellerRatingThumbCountProps = {
  thumbUpCount: number;
  thumbDownCount: number;
  title: string;
  className?: string;
};

export const SellerRatingThumbCount: React.FC<SellerRatingThumbCountProps> = ({
  thumbUpCount,
  thumbDownCount,
  title,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.title}>
      {title}
    </div>
    <div className={s.blockInfo}>
      <div className={s.row}>
        <ThumbsUpIcon
          className={classNames(s.icon, s.positive)}
          width='20'
          height='20'
        />
        <div className={s.quantity}>{thumbUpCount}</div>
      </div>
      <div className={s.row}>
        <ThumbsUpIcon
          className={classNames(s.icon, s.negative)}
          width='20'
          height='20'
        />
        <div className={s.quantity}>{thumbDownCount}</div>
      </div>
    </div>
  </div>
);
